import React, {Component} from 'react';
import {Route, Switch} from "react-router-dom";
import {Helmet} from "react-helmet";
import {withBreadcrumb} from "../../Boilerplate/BreadcrumbContext";
import SubmittalList from "./SubmittalList";
import SubmittalNew from "./SubmittalNew";
import Submittal from "./Submittal";

class Submittals extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>Submittals</title>
        </Helmet>
        <Switch>
          <Route component={SubmittalUi}/>
        </Switch>
      </div>
    );
  }
}

const SubmittalUi = () => (
  <div>
    <Route exact path="/projects/:id/submittals/" component={SubmittalList}/>
    <Switch>
      <Route path="/projects/:id/submittals/new" component={SubmittalNew}/>
      <Route path="/projects/:id/submittals/:submittalId" component={Submittal}/>
    </Switch>
  </div>
);

export default withBreadcrumb(
  ({ match }) => ({ title: 'Submittals', path: `/projects/${match.params.id}/submittals/`}),
  Submittals
);



// WEBPACK FOOTER //
// ./src/components/Projects/Submittals/Submittals.js